import React, { useMemo } from 'react';
import { Box, Text, useResponsive } from '@common-fe/common-fe';


interface Props {
  title: string;
  description: string;
  icon: React.ReactNode;
  testId?: string;
  children?: React.ReactNode;
  isWideMode?: boolean;
}

const BannerBase: React.FC<Props> = ({ title, description, icon, testId, children, isWideMode }) => {
  const { isMobile } = useResponsive();
  const sizeOfImage = useMemo(() => {
    if (isMobile) {
      return '150px';
    }
    return '200px';
  }, [isMobile]);
  return (
    <Box
      width={isWideMode || isMobile ? undefined : '984px'}
      pad={{ left: 'l', right: isMobile ? 's' : 'xxxl', vertical: 's' }}
      direction="row"
      round="container1Round"
      background={{ color: 'canvas' }}
      border={{ color: 'border2', size: '1px' }}
      align="center"
      data-testId={`${testId}_banner`}
    >
      <Box
        direction={isMobile ? 'column' : undefined}
        width={{ max: isWideMode || isMobile ? undefined : '665px', width: '100%' }}
      >
        <Box>
          <Text
            data-testId={`${testId}_banner_title`}
            weight="bold"
            size={isMobile ? 'l' : '2xl'}
            truncate={isMobile}
          >
            {title}
          </Text>
        </Box>

        <Box margin={{ top: 'xs' }}>
          <Text size="medium" data-testId={`${testId}_banner_description`}>
            {description}
          </Text>
        </Box>

        {children}
      </Box>

      <Box
        margin={{ left: 'l' }}
        justify="center"
        align="center"
        data-testId={`${testId}_banner_icon`}
        width={{ width: sizeOfImage, min: sizeOfImage }}
        height={{ height: sizeOfImage, min: sizeOfImage }}
      >
        {icon}
      </Box>
    </Box>
  );
};

export default BannerBase;
